import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound({ title = 'Page Not Found', message = 'The page you are looking for does not exist or has no content.', backTo = '/' }) {
  return (
    <div className="container py-5 text-center">
      <h2 className="mb-3">{title}</h2>
      <p className="mb-4">{message}</p>
      <Link className="btn btn-primary" to={backTo}>Go Home</Link>
    </div>
  );
}

